import React from 'react';
interface KhatianDocumentProps {
  khatian: any;
}
export const KhatianDocument: React.FC<KhatianDocumentProps> = ({
  khatian
}) => {
  return <div className="bg-white p-8 border border-slate-300 shadow-sm max-w-4xl mx-auto font-bengali text-sm text-black" data-id="element-37">
      {/* Header */}
      <div className="flex justify-between items-start mb-6" data-id="element-38">
        <div className="flex-1 text-center" data-id="element-39">
          <h1 className="text-2xl font-bold" data-id="element-40">
            খতিয়ান নং- {khatian?.khatianNo || '৫৩৩৮'}
          </h1>
        </div>
        <div className="text-right" data-id="element-41">
          <p data-id="element-42">পৃষ্ঠা নংঃ ১</p>
        </div>
      </div>

      {/* Location Info */}
      <div className="flex justify-between border-b border-black pb-2 mb-2 text-sm font-medium" data-id="element-43">
        <div data-id="element-44">বিভাগঃ {khatian?.division || 'ঢাকা'}</div>
        <div data-id="element-45">জেলাঃ {khatian?.district || 'ঢাকা'}</div>
        <div data-id="element-46">উপজেলা/থানাঃ {khatian?.upazila || 'পল্লবী'}</div>
        <div data-id="element-47">মৌজাঃ {khatian?.mouja || 'উত্তর সেনপাড়া/পর্বতা'}</div>
        <div data-id="element-48">জে, এল, নংঃ {khatian?.jlNo || '০১১'}</div>
        <div data-id="element-49">রেঃ সাঃ নংঃ</div>
      </div>

      {/* Main Table */}
      <table className="w-full border-collapse border border-black text-xs text-center" data-id="element-50">
        <thead data-id="element-51">
          <tr data-id="element-52">
            <th className="border border-black p-1 w-1/4" rowSpan={2} data-id="element-53">
              মালিক, অকৃষি প্রজা বা ইজারাদারের
              <br data-id="element-54" />
              নাম ও ঠিকানা
            </th>
            <th className="border border-black p-1" rowSpan={2} data-id="element-55">
              অংশ
            </th>
            <th className="border border-black p-1" rowSpan={2} data-id="element-56">
              রাজস্ব
            </th>
            <th className="border border-black p-1" rowSpan={2} data-id="element-57">
              দাগ নং
            </th>
            <th className="border border-black p-1" colSpan={2} data-id="element-58">
              জমির শ্রেণি
            </th>
            <th className="border border-black p-1" colSpan={2} data-id="element-59">
              দাগের মোট
              <br data-id="element-60" />
              পরিমাণ
            </th>
            <th className="border border-black p-1" rowSpan={2} data-id="element-61">
              দাগের মধ্যে অত্র
              <br data-id="element-62" />
              খতিয়ানের অংশ
            </th>
            <th className="border border-black p-1" colSpan={2} data-id="element-63">
              অংশানুযায়ী জমির
              <br data-id="element-64" />
              পরিমাণ
            </th>
            <th className="border border-black p-1 w-1/6" rowSpan={2} data-id="element-65">
              দখল বিষয়ক বা অন্যান্য
              <br data-id="element-66" />
              বিশেষ মন্তব্য
            </th>
          </tr>
          <tr data-id="element-67">
            <th className="border border-black p-1" data-id="element-68">
              কৃষি
              <br data-id="element-69" />৫ (ক)
            </th>
            <th className="border border-black p-1" data-id="element-70">
              অকৃষি
              <br data-id="element-71" />
              ৫(খ)
            </th>
            <th className="border border-black p-1" data-id="element-72">
              একর
              <br data-id="element-73" />৬ (ক)
            </th>
            <th className="border border-black p-1" data-id="element-74">
              শতাংশ
              <br data-id="element-75" />৬ (খ)
            </th>
            <th className="border border-black p-1" data-id="element-76">
              একর
              <br data-id="element-77" />৮ (ক)
            </th>
            <th className="border border-black p-1" data-id="element-78">
              শতাংশ
              <br data-id="element-79" />৮ (খ)
            </th>
          </tr>
          <tr className="bg-slate-50" data-id="element-80">
            <th className="border border-black p-1" data-id="element-81">১</th>
            <th className="border border-black p-1" data-id="element-82">২</th>
            <th className="border border-black p-1" data-id="element-83">৩</th>
            <th className="border border-black p-1" data-id="element-84">৪</th>
            <th className="border border-black p-1" colSpan={2} data-id="element-85">
              ৫
            </th>
            <th className="border border-black p-1" colSpan={2} data-id="element-86">
              ৬
            </th>
            <th className="border border-black p-1" data-id="element-87">৭</th>
            <th className="border border-black p-1" colSpan={2} data-id="element-88">
              ৮
            </th>
            <th className="border border-black p-1" data-id="element-89">৯</th>
          </tr>
        </thead>
        <tbody data-id="element-90">
          <tr data-id="element-91">
            <td className="border border-black p-2 text-left align-top" data-id="element-92">
              <p className="font-bold underline mb-1" data-id="element-93">মালিক</p>
              <p data-id="element-94">{khatian?.ownerName || 'দং আবদুল জব্বার মিয়া'}</p>
              <p data-id="element-95">পিং {khatian?.fatherName || 'নুর মোহাম্মদ বাড়ী'}</p>
              <p className="mt-2" data-id="element-96">মিসেস নাজমে আরা জহুরা খাতুন</p>
              <p data-id="element-97">পিং রেজাউর রহমান খান</p>
              <p className="mt-2" data-id="element-98">ডাঃ ইসরাত জাহান ডলি</p>
              <p data-id="element-99">পিং মোঃ হাবিব উল্লা</p>
              <p className="mt-4" data-id="element-100">আরজুমান্দ বানু দেবী</p>
              <p data-id="element-101">পিং হাবিব উল্লা</p>
              <p data-id="element-102">বাড়ী নং ৪ রোড নং ৩৪</p>
              <p data-id="element-103">ব্লক ট, সেকশন ৬</p>
              <p data-id="element-104">থানা পল্লবী</p>
            </td>
            <td className="border border-black p-1 align-top" data-id="element-105">
              <p data-id="element-106">০.২৫০</p>
              <p className="mt-6" data-id="element-107">০.২৫০</p>
              <p className="mt-6" data-id="element-108">০.২৫০</p>
              <p className="mt-8" data-id="element-109">০.২৫০</p>
            </td>
            <td className="border border-black p-1 align-top" data-id="element-110"></td>
            <td className="border border-black p-1 align-top" data-id="element-111">১৯১৮৬</td>
            <td className="border border-black p-1 align-top" data-id="element-112"></td>
            <td className="border border-black p-1 align-top" data-id="element-113">বাড়ী</td>
            <td className="border border-black p-1 align-top" data-id="element-114"></td>
            <td className="border border-black p-1 align-top" data-id="element-115"></td>
            <td className="border border-black p-1 align-top" data-id="element-116">১.০০০</td>
            <td className="border border-black p-1 align-top" data-id="element-117"></td>
            <td className="border border-black p-1 align-top" data-id="element-118">০২৮০</td>
            <td className="border border-black p-1 align-top" data-id="element-119"></td>
          </tr>
          {/* Empty rows to fill space if needed, matching the image style */}
          <tr data-id="element-120">
            <td className="border border-black p-1 h-32" data-id="element-121"></td>
            <td className="border border-black p-1" data-id="element-122"></td>
            <td className="border border-black p-1" data-id="element-123"></td>
            <td className="border border-black p-1" data-id="element-124"></td>
            <td className="border border-black p-1" data-id="element-125"></td>
            <td className="border border-black p-1" data-id="element-126"></td>
            <td className="border border-black p-1" data-id="element-127"></td>
            <td className="border border-black p-1" data-id="element-128"></td>
            <td className="border border-black p-1" data-id="element-129"></td>
            <td className="border border-black p-1" data-id="element-130"></td>
            <td className="border border-black p-1" data-id="element-131"></td>
            <td className="border border-black p-1" data-id="element-132"></td>
          </tr>
          <tr data-id="element-133">
            <td className="border border-black p-1 text-left text-[10px]" data-id="element-134">
              ......... ধারামতে নোট বা পরিবর্তন{' '}
              <span className="font-bold" data-id="element-135">
                যার মোকদ্দমা নং......... এবং সন.........
              </span>
            </td>
            <td className="border border-black p-1 font-bold" data-id="element-136">১.০০০</td>
            <td className="border border-black p-1 col-span-6 text-right font-bold" colSpan={6} data-id="element-137">
              মোট জমিঃ
            </td>
            <td className="border border-black p-1" data-id="element-138"></td>
            <td className="border border-black p-1 font-bold" data-id="element-139">০</td>
            <td className="border border-black p-1 font-bold" data-id="element-140">২৮০</td>
            <td className="border border-black p-1" data-id="element-141"></td>
          </tr>
        </tbody>
      </table>

      {/* Footer */}
      <div className="flex justify-between items-end mt-6 text-xs" data-id="element-142">
        <div data-id="element-143">
          <p data-id="element-144">মুদ্রণঃ সেটেলমেন্ট প্রেস, ঢাকা। তারিখঃ ১৫-০৫-২০২৩</p>
          <p className="mt-4" data-id="element-145">বাংলাদেশ ফর্ম নং ৫৪৬২ (সংশোধিত)</p>
        </div>
        <div className="text-right flex flex-col items-end" data-id="element-146">
          <p className="mb-2" data-id="element-147">কম্পিউটার কোডঃ ৪৩০৫১৫১৬১০৩১০১১৬৬-০২০২৩৪৪</p>
          <div className="w-16 h-16 bg-slate-200 border border-slate-400 flex items-center justify-center" data-id="element-148">
            <span className="text-[8px] text-slate-500" data-id="element-149">QR Code</span>
          </div>
        </div>
      </div>
    </div>;
};